export interface ILeaderboardTable {
  id: number;
  projectId: string;
  name: string;
  sortAsc: boolean;
  date: string;
  minValue: number;
  maxValue: number;
  recordsLimit: number;
  allowGuestScores: boolean;
  uniqueScorePerPlayer: boolean;
  published: boolean;
  hasSecret: boolean;
}